const defaultOptions = {
    radius: 8,
    stroke: 2,
    toggleWidth: 30,
    isLeft: true,
    text1Top: '',
    text1Bottom: '',
    text2Top: '',
    text2Bottom: '',
}

function getTogglePosition(options, isLeft) {
    const { radius, toggleWidth } = options

    const cx = isLeft ? radius : toggleWidth - radius
    const dx = isLeft ? toggleWidth / -2 : toggleWidth / 2

    return { cx, dx }
}

function getToggleText(options, isLeft) {
    const { text1Top, text1Bottom, text2Top, text2Bottom } = options
    const text = isLeft ? text1Bottom : text2Bottom
    const text2 = isLeft ? text1Top : text2Top

    return [text, text2]
}

function updateToggleText(
    options,
    isLeft,
    toggleCircle,
    toggleText,
    toggleText2
) {
    const { cx, dx } = getTogglePosition(options, isLeft)
    const [text1, text2] = getToggleText(options, isLeft)

    Promise.all([
        toggleCircle.transition().attr('cx', cx).end(),
        toggleText.transition().attr('dx', dx).end(),
        toggleText2.transition().attr('dx', dx).end(),
    ]).then(() => {
        toggleText.text(text1)
        toggleText2.text(text2)
    })
}

let isLeft = true

export default function createToggle(element, callback, suppliedOptions = {}) {
    const options = { ...defaultOptions, ...suppliedOptions }

    const { radius, stroke, toggleWidth } = options

    isLeft = options.isLeft

    const { cx, dx } = getTogglePosition(options, isLeft)
    const [text1, text2] = getToggleText(options, isLeft)

    element
        .append('rect')
        .attr('height', radius * 2)
        .attr('width', toggleWidth)
        .attr('fill', '#bbb')
        .attr('rx', radius)

    const toggleCircle = element
        .append('circle')
        .attr('r', radius - stroke)
        .attr('fill', '#fff')
        .attr('stroke', '#959595')
        .attr('stroke-width', stroke)
        .attr('cx', cx)
        .attr('cy', radius)

    const toggleText = element
        .append('text')
        .attr('text-anchor', 'middle')
        .attr('x', toggleWidth / 2)
        .attr('dx', dx)
        .attr('y', -3)
        .attr('fill', 'rgb(104, 146, 162)')
        .attr('font-size', 10)
        .attr('font-weight', 'normal')
        .attr('font-family', 'Roboto Condensed')
        .text(text1)

    const toggleText2 = element
        .append('text')
        .attr('text-anchor', 'middle')
        .attr('x', toggleWidth / 2)
        .attr('dx', dx)
        .attr('y', -14)
        .attr('fill', 'rgb(104, 146, 162)')
        .attr('font-size', 10)
        .attr('font-weight', 'normal')
        .attr('font-family', 'Roboto Condensed')
        .text(text2)

    element
        .on('click', () => {
            isLeft = !isLeft
            updateToggleText(
                options,
                isLeft,
                toggleCircle,
                toggleText,
                toggleText2
            )
            callback(isLeft)
        })
        .style('cursor', 'pointer')
}
